import { Component } from '@angular/core';

@Component({
  selector: 'notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.scss']
})
export class NotFoundComponent {

  slogan: string = "Error 404"

  constructor() { }

}
